module.exports = __webpack_public_path__ + "img/whatsapplogo.00760b7b.png";